/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {ChangeRequest} from '../models/ChangeRequest';
import type {ChangeRequestAuthor} from '../models/ChangeRequestAuthor';
import type {ChangeRequestComment} from '../models/ChangeRequestComment';
import type {DateInfo} from '../models/DateInfo';
import type {Error} from '../models/Error';
import type {EventType} from '../models/EventType';
import type {SaveChangeRequestComment} from '../models/SaveChangeRequestComment';
import type {UpdateChangeRequestComment} from '../models/UpdateChangeRequestComment';

export interface GetAllChangeRequests$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAllChangeRequestsRequest = createAction<PayloadData<void>>('CHANGE_REQUEST_CONTROLLER__GET_ALL_CHANGE_REQUESTS__REQUEST');
export const getAllChangeRequestsSuccess = createAction<PayloadData<Array<ChangeRequest>>>('CHANGE_REQUEST_CONTROLLER__GET_ALL_CHANGE_REQUESTS__SUCCESS');
export const getAllChangeRequestsFailure = createAction<PayloadData<Error, void, true>>('CHANGE_REQUEST_CONTROLLER__GET_ALL_CHANGE_REQUESTS__FAILURE');

export const getAllChangeRequestsActions = [
    getAllChangeRequestsRequest,
    getAllChangeRequestsSuccess,
    getAllChangeRequestsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAllChangeRequests = (config?: GetAllChangeRequests$Config) => {
    return {
        CALL_API: {
            types: getAllChangeRequestsActions,
            method: ApiMethods.GET,
            endpoint: `/change-requests`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetChangeRequestByCodeAndSourceAndType$Request {
    eventCode: string;
    eventSource: string;
    eventType: EventType;
}

export interface GetChangeRequestByCodeAndSourceAndType$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getChangeRequestByCodeAndSourceAndTypeRequest = createAction<PayloadData<void, GetChangeRequestByCodeAndSourceAndType$Request>>('CHANGE_REQUEST_CONTROLLER__GET_CHANGE_REQUEST_BY_CODE_AND_SOURCE_AND_TYPE__REQUEST');
export const getChangeRequestByCodeAndSourceAndTypeSuccess = createAction<PayloadData<Array<ChangeRequest>, GetChangeRequestByCodeAndSourceAndType$Request>>('CHANGE_REQUEST_CONTROLLER__GET_CHANGE_REQUEST_BY_CODE_AND_SOURCE_AND_TYPE__SUCCESS');
export const getChangeRequestByCodeAndSourceAndTypeFailure = createAction<PayloadData<Error, GetChangeRequestByCodeAndSourceAndType$Request, true>>('CHANGE_REQUEST_CONTROLLER__GET_CHANGE_REQUEST_BY_CODE_AND_SOURCE_AND_TYPE__FAILURE');

export const getChangeRequestByCodeAndSourceAndTypeActions = [
    getChangeRequestByCodeAndSourceAndTypeRequest,
    getChangeRequestByCodeAndSourceAndTypeSuccess,
    getChangeRequestByCodeAndSourceAndTypeFailure
] as const;

/**
 * @param {string} meta.eventCode Event Code
 * @param {string} meta.eventSource Event Source
 * @param {EventType} meta.eventType Event Type
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getChangeRequestByCodeAndSourceAndType = (meta: GetChangeRequestByCodeAndSourceAndType$Request, config?: GetChangeRequestByCodeAndSourceAndType$Config) => {
    const TRANSPORT_GET_PARAMS = {
        eventCode: meta.eventCode,
        eventSource: meta.eventSource,
        eventType: meta.eventType,
    };
    return {
        CALL_API: {
            types: getChangeRequestByCodeAndSourceAndTypeActions,
            method: ApiMethods.GET,
            endpoint: `/change-requests/by-code-source-type`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetChangeRequestById$Request {
    id: number;
}

export interface GetChangeRequestById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getChangeRequestByIdRequest = createAction<PayloadData<void, GetChangeRequestById$Request>>('CHANGE_REQUEST_CONTROLLER__GET_CHANGE_REQUEST_BY_ID__REQUEST');
export const getChangeRequestByIdSuccess = createAction<PayloadData<ChangeRequest, GetChangeRequestById$Request>>('CHANGE_REQUEST_CONTROLLER__GET_CHANGE_REQUEST_BY_ID__SUCCESS');
export const getChangeRequestByIdFailure = createAction<PayloadData<Error, GetChangeRequestById$Request, true>>('CHANGE_REQUEST_CONTROLLER__GET_CHANGE_REQUEST_BY_ID__FAILURE');

export const getChangeRequestByIdActions = [
    getChangeRequestByIdRequest,
    getChangeRequestByIdSuccess,
    getChangeRequestByIdFailure
] as const;

/**
 * @param {number} meta.id Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getChangeRequestById = (meta: GetChangeRequestById$Request, config?: GetChangeRequestById$Config) => {
    return {
        CALL_API: {
            types: getChangeRequestByIdActions,
            method: ApiMethods.GET,
            endpoint: `/change-requests/${meta.id}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetChangeRequestCount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getChangeRequestCountRequest = createAction<PayloadData<void>>('CHANGE_REQUEST_CONTROLLER__GET_CHANGE_REQUEST_COUNT__REQUEST');
export const getChangeRequestCountSuccess = createAction<PayloadData<number>>('CHANGE_REQUEST_CONTROLLER__GET_CHANGE_REQUEST_COUNT__SUCCESS');
export const getChangeRequestCountFailure = createAction<PayloadData<Error, void, true>>('CHANGE_REQUEST_CONTROLLER__GET_CHANGE_REQUEST_COUNT__FAILURE');

export const getChangeRequestCountActions = [
    getChangeRequestCountRequest,
    getChangeRequestCountSuccess,
    getChangeRequestCountFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getChangeRequestCount = (config?: GetChangeRequestCount$Config) => {
    return {
        CALL_API: {
            types: getChangeRequestCountActions,
            method: ApiMethods.GET,
            endpoint: `/change-requests/count`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetChangeRequestDueDate$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getChangeRequestDueDateRequest = createAction<PayloadData<void>>('CHANGE_REQUEST_CONTROLLER__GET_CHANGE_REQUEST_DUE_DATE__REQUEST');
export const getChangeRequestDueDateSuccess = createAction<PayloadData<DateInfo>>('CHANGE_REQUEST_CONTROLLER__GET_CHANGE_REQUEST_DUE_DATE__SUCCESS');
export const getChangeRequestDueDateFailure = createAction<PayloadData<Error, void, true>>('CHANGE_REQUEST_CONTROLLER__GET_CHANGE_REQUEST_DUE_DATE__FAILURE');

export const getChangeRequestDueDateActions = [
    getChangeRequestDueDateRequest,
    getChangeRequestDueDateSuccess,
    getChangeRequestDueDateFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getChangeRequestDueDate = (config?: GetChangeRequestDueDate$Config) => {
    return {
        CALL_API: {
            types: getChangeRequestDueDateActions,
            method: ApiMethods.GET,
            endpoint: `/change-requests/due-date`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetCommentsByChangeRequestId$Request {
    changeRequestId: number;
}

export interface GetCommentsByChangeRequestId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getCommentsByChangeRequestIdRequest = createAction<PayloadData<void, GetCommentsByChangeRequestId$Request>>('CHANGE_REQUEST_CONTROLLER__GET_COMMENTS_BY_CHANGE_REQUEST_ID__REQUEST');
export const getCommentsByChangeRequestIdSuccess = createAction<PayloadData<Array<ChangeRequestComment>, GetCommentsByChangeRequestId$Request>>('CHANGE_REQUEST_CONTROLLER__GET_COMMENTS_BY_CHANGE_REQUEST_ID__SUCCESS');
export const getCommentsByChangeRequestIdFailure = createAction<PayloadData<Error, GetCommentsByChangeRequestId$Request, true>>('CHANGE_REQUEST_CONTROLLER__GET_COMMENTS_BY_CHANGE_REQUEST_ID__FAILURE');

export const getCommentsByChangeRequestIdActions = [
    getCommentsByChangeRequestIdRequest,
    getCommentsByChangeRequestIdSuccess,
    getCommentsByChangeRequestIdFailure
] as const;

/**
 * @param {number} meta.changeRequestId Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getCommentsByChangeRequestId = (meta: GetCommentsByChangeRequestId$Request, config?: GetCommentsByChangeRequestId$Config) => {
    return {
        CALL_API: {
            types: getCommentsByChangeRequestIdActions,
            method: ApiMethods.GET,
            endpoint: `/change-requests/comments/${meta.changeRequestId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetPreviouslyApprovedChangeRequestById$Request {
    id: number;
}

export interface GetPreviouslyApprovedChangeRequestById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getPreviouslyApprovedChangeRequestByIdRequest = createAction<PayloadData<void, GetPreviouslyApprovedChangeRequestById$Request>>('CHANGE_REQUEST_CONTROLLER__GET_PREVIOUSLY_APPROVED_CHANGE_REQUEST_BY_ID__REQUEST');
export const getPreviouslyApprovedChangeRequestByIdSuccess = createAction<PayloadData<ChangeRequest, GetPreviouslyApprovedChangeRequestById$Request>>('CHANGE_REQUEST_CONTROLLER__GET_PREVIOUSLY_APPROVED_CHANGE_REQUEST_BY_ID__SUCCESS');
export const getPreviouslyApprovedChangeRequestByIdFailure = createAction<PayloadData<Error, GetPreviouslyApprovedChangeRequestById$Request, true>>('CHANGE_REQUEST_CONTROLLER__GET_PREVIOUSLY_APPROVED_CHANGE_REQUEST_BY_ID__FAILURE');

export const getPreviouslyApprovedChangeRequestByIdActions = [
    getPreviouslyApprovedChangeRequestByIdRequest,
    getPreviouslyApprovedChangeRequestByIdSuccess,
    getPreviouslyApprovedChangeRequestByIdFailure
] as const;

/**
 * @param {number} meta.id Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getPreviouslyApprovedChangeRequestById = (meta: GetPreviouslyApprovedChangeRequestById$Request, config?: GetPreviouslyApprovedChangeRequestById$Config) => {
    return {
        CALL_API: {
            types: getPreviouslyApprovedChangeRequestByIdActions,
            method: ApiMethods.GET,
            endpoint: `/change-requests/previously-approved/${meta.id}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RemoveChangeRequestById$Request {
    id: number;
}

export interface RemoveChangeRequestById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const removeChangeRequestByIdRequest = createAction<PayloadData<void, RemoveChangeRequestById$Request>>('CHANGE_REQUEST_CONTROLLER__REMOVE_CHANGE_REQUEST_BY_ID__REQUEST');
export const removeChangeRequestByIdSuccess = createAction<PayloadData<void, RemoveChangeRequestById$Request>>('CHANGE_REQUEST_CONTROLLER__REMOVE_CHANGE_REQUEST_BY_ID__SUCCESS');
export const removeChangeRequestByIdFailure = createAction<PayloadData<Error, RemoveChangeRequestById$Request, true>>('CHANGE_REQUEST_CONTROLLER__REMOVE_CHANGE_REQUEST_BY_ID__FAILURE');

export const removeChangeRequestByIdActions = [
    removeChangeRequestByIdRequest,
    removeChangeRequestByIdSuccess,
    removeChangeRequestByIdFailure
] as const;

/**
 * @param {number} meta.id Change Request Id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const removeChangeRequestById = (meta: RemoveChangeRequestById$Request, config?: RemoveChangeRequestById$Config) => {
    return {
        CALL_API: {
            types: removeChangeRequestByIdActions,
            method: ApiMethods.DELETE,
            endpoint: `/change-requests/remove/${meta.id}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveChangeRequest$Request {
    changeRequest: ChangeRequest;
}

export interface SaveChangeRequest$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveChangeRequestRequest = createAction<PayloadData<void, SaveChangeRequest$Request>>('CHANGE_REQUEST_CONTROLLER__SAVE_CHANGE_REQUEST__REQUEST');
export const saveChangeRequestSuccess = createAction<PayloadData<number, SaveChangeRequest$Request>>('CHANGE_REQUEST_CONTROLLER__SAVE_CHANGE_REQUEST__SUCCESS');
export const saveChangeRequestFailure = createAction<PayloadData<Error, SaveChangeRequest$Request, true>>('CHANGE_REQUEST_CONTROLLER__SAVE_CHANGE_REQUEST__FAILURE');

export const saveChangeRequestActions = [
    saveChangeRequestRequest,
    saveChangeRequestSuccess,
    saveChangeRequestFailure
] as const;

/**
 * @param {ChangeRequest} meta.changeRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveChangeRequest = (meta: SaveChangeRequest$Request, config?: SaveChangeRequest$Config) => {
    return {
        CALL_API: {
            types: saveChangeRequestActions,
            method: ApiMethods.POST,
            endpoint: `/change-requests/save`,
            TRANSPORT_REQUEST_BODY: meta.changeRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveComment$Request {
    saveChangeRequestComment: SaveChangeRequestComment;
}

export interface SaveComment$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveCommentRequest = createAction<PayloadData<void, SaveComment$Request>>('CHANGE_REQUEST_CONTROLLER__SAVE_COMMENT__REQUEST');
export const saveCommentSuccess = createAction<PayloadData<void, SaveComment$Request>>('CHANGE_REQUEST_CONTROLLER__SAVE_COMMENT__SUCCESS');
export const saveCommentFailure = createAction<PayloadData<Error, SaveComment$Request, true>>('CHANGE_REQUEST_CONTROLLER__SAVE_COMMENT__FAILURE');

export const saveCommentActions = [
    saveCommentRequest,
    saveCommentSuccess,
    saveCommentFailure
] as const;

/**
 * @param {SaveChangeRequestComment} meta.saveChangeRequestComment
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveComment = (meta: SaveComment$Request, config?: SaveComment$Config) => {
    return {
        CALL_API: {
            types: saveCommentActions,
            method: ApiMethods.POST,
            endpoint: `/change-requests/comments/save`,
            TRANSPORT_REQUEST_BODY: meta.saveChangeRequestComment,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateAuthor$Request {
    changeRequestAuthor: ChangeRequestAuthor;
}

export interface UpdateAuthor$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAuthorRequest = createAction<PayloadData<void, UpdateAuthor$Request>>('CHANGE_REQUEST_CONTROLLER__UPDATE_AUTHOR__REQUEST');
export const updateAuthorSuccess = createAction<PayloadData<void, UpdateAuthor$Request>>('CHANGE_REQUEST_CONTROLLER__UPDATE_AUTHOR__SUCCESS');
export const updateAuthorFailure = createAction<PayloadData<Error, UpdateAuthor$Request, true>>('CHANGE_REQUEST_CONTROLLER__UPDATE_AUTHOR__FAILURE');

export const updateAuthorActions = [
    updateAuthorRequest,
    updateAuthorSuccess,
    updateAuthorFailure
] as const;

/**
 * @param {ChangeRequestAuthor} meta.changeRequestAuthor
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAuthor = (meta: UpdateAuthor$Request, config?: UpdateAuthor$Config) => {
    return {
        CALL_API: {
            types: updateAuthorActions,
            method: ApiMethods.PUT,
            endpoint: `/change-requests/authors/update`,
            TRANSPORT_REQUEST_BODY: meta.changeRequestAuthor,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateChangeRequest$Request {
    changeRequest: ChangeRequest;
}

export interface UpdateChangeRequest$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateChangeRequestRequest = createAction<PayloadData<void, UpdateChangeRequest$Request>>('CHANGE_REQUEST_CONTROLLER__UPDATE_CHANGE_REQUEST__REQUEST');
export const updateChangeRequestSuccess = createAction<PayloadData<void, UpdateChangeRequest$Request>>('CHANGE_REQUEST_CONTROLLER__UPDATE_CHANGE_REQUEST__SUCCESS');
export const updateChangeRequestFailure = createAction<PayloadData<Error, UpdateChangeRequest$Request, true>>('CHANGE_REQUEST_CONTROLLER__UPDATE_CHANGE_REQUEST__FAILURE');

export const updateChangeRequestActions = [
    updateChangeRequestRequest,
    updateChangeRequestSuccess,
    updateChangeRequestFailure
] as const;

/**
 * @param {ChangeRequest} meta.changeRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateChangeRequest = (meta: UpdateChangeRequest$Request, config?: UpdateChangeRequest$Config) => {
    return {
        CALL_API: {
            types: updateChangeRequestActions,
            method: ApiMethods.PUT,
            endpoint: `/change-requests/update`,
            TRANSPORT_REQUEST_BODY: meta.changeRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateComment$Request {
    updateChangeRequestComment: UpdateChangeRequestComment;
}

export interface UpdateComment$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateCommentRequest = createAction<PayloadData<void, UpdateComment$Request>>('CHANGE_REQUEST_CONTROLLER__UPDATE_COMMENT__REQUEST');
export const updateCommentSuccess = createAction<PayloadData<void, UpdateComment$Request>>('CHANGE_REQUEST_CONTROLLER__UPDATE_COMMENT__SUCCESS');
export const updateCommentFailure = createAction<PayloadData<Error, UpdateComment$Request, true>>('CHANGE_REQUEST_CONTROLLER__UPDATE_COMMENT__FAILURE');

export const updateCommentActions = [
    updateCommentRequest,
    updateCommentSuccess,
    updateCommentFailure
] as const;

/**
 * @param {UpdateChangeRequestComment} meta.updateChangeRequestComment
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateComment = (meta: UpdateComment$Request, config?: UpdateComment$Config) => {
    return {
        CALL_API: {
            types: updateCommentActions,
            method: ApiMethods.PUT,
            endpoint: `/change-requests/comments/update`,
            TRANSPORT_REQUEST_BODY: meta.updateChangeRequestComment,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

